// extracted by mini-css-extract-plugin
export default {"backToLoginLink":"BackToLogin-module__backToLoginLink__zTeF","container":"BackToLogin-module__container_PgERM"};